import store from "@/store";
import axios from "axios";
axios.interceptors.response.use(
  (response) => response,

  async (error) => {
    // Ignore cancelled/aborted requests
    if (
      error.code === "ERR_CANCELED" ||
      error.message === "canceled" ||
      error.message === "Request aborted"
    ) {
      return Promise.reject(error);
    }

    const res = error.response;

    if (res) {
      const msg = res.data?.detail || "";

      if (
        res.status === 401 ||
        res.status === 403 ||
        msg.includes("Invalid token")
      ) {
        try {
          // Prevent infinite loop
          if (window.isLoggingOut) {
            return Promise.reject(error);
          }

          window.isLoggingOut = true;

          // Close sockets
          store.commit("CLOSE_SOCKET");
          store.commit("closeWebSocket");

          // Clear storage
          localStorage.removeItem("userInfo");
          localStorage.removeItem("LmsId");
          sessionStorage.clear();

          // Reset vuex
          store.commit("logout");

          // Delay redirect slightly
          setTimeout(() => {
            window.location.replace("/");
          }, 100);
        } catch (e) {
          console.error("Logout redirect error:", e);
        }
      }
    }

    return Promise.reject(error);
  },
);


export const studentCourseGuards = (to, from, next) => {

    const courseId = to.params.course_id;

    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "student"){
            // next();
            axios.get(`${process.env.VUE_APP_API}/course-permission/${courseId}/?Key=${store.getters.userInfo.token_key}`)
                .then((response)=>{
                    if(response.data.status == 200){
                        next();
                    } 
                    else{
                        alert("not have course permisson");
                        setTimeout(()=>{
                            next("/student/mycourse");
                        },200)
                        return;
                    }  
                })
                .catch((error)=>{
                    alert("not have course permisson");
                     setTimeout(()=>{
                            next("/student/mycourse");
                        },200)
                    return;
                })
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};



export const adminhodcodGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "super_admin"  ||  store.getters.userInfo.user.permission == "hod" || store.getters.userInfo.user.permission == "co-ordinator" || store.getters.userInfo.user.permission == "instructor"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const isloginGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
    } 
    else{
        next("/");
    }
};


export const hodGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "hod"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};


export const mentorGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "mentor"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const coOrdianateGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "co-ordinator"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const adminGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "super_admin"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};


export const studentGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "student"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};

export const instructorGuards = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        if(store.getters.userInfo.user.permission == "instructor"){
            next();
        }
        else{
            next("/");
        }
    } 
    else{
        next("/");
    }
};


export const loginGuards = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
    } 
    else {
        if(store.getters.userInfo.user.permission == "super_admin"){
            next("/admin/home");
        }
        if(store.getters.userInfo.user.permission == "student"){
            next("/student/home");
        }
        if(store.getters.userInfo.user.permission == "instructor"){
            next("/instructor/home");
        }
        if(store.getters.userInfo.user.permission == "hod"){
            next("/hod/home");
        }
        if(store.getters.userInfo.user.permission == "mentor"){
            next("/mentor/home");
        }
        if(store.getters.userInfo.user.permission == "co-ordinator"){
            next("/coordinater/home");
        }
    }
};

